module.exports = __webpack_public_path__ + "img/logo-dark4.52c42eb3.svg";